import axiosInstance from '../axiosInstance';

export const addQuestionAnswer = async ({ qnaId, content }) => {
  try {
    const response = await axiosInstance.post('/qna/answer', {
      qnaId,
      content,
    });
    return response.data.data;
  } catch (error) {
    console.error('Add QnA Answer API Error:', error);
    throw error;
  }
};

export const updateQuestionAnswer = async ({ answerId, content }) => {
  try {
    const response = await axiosInstance.put(`/qna/answer/${answerId}`, {
      content,
    });
    return response.data;
  } catch (error) {
    console.error('Update QnA Answer API Error:', error);
    throw error;
  }
};
